<template>
    <div>
        <v-card>
            <v-card-text>
                <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="salvaModelloStandard()"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva come modello standard</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="dialog_modello_standard = true"
              class="mr-5"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary">mdi-download</v-icon>
            </v-btn></template
          >
          <span>Modelli standard</span>
        </v-tooltip> -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="mr-5"
                            @click="getHTML()"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="primary"> mdi-xml </v-icon>
                        </v-btn>
                    </template>
                    <span>Ottieni HTML dalla query del messaggio</span>
                </v-tooltip>

                <v-row dense align="center" class="ml-5 mr-5">
                    <v-col cols="8">
                        <v-text-field
                            label="Nome modello"
                            v-model="modello.des_modello"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row dense align="center" class="ml-5 mr-5">
                    <v-col cols="8">
                        <v-text-field label="Oggetto" v-model="modello.oggetto">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row dense align="center" class="ml-5 mr-5">
                    <v-col cols="12">
                        <v-text-field label="Header" v-model="modello.header">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row dense align="center" class="ml-5 mr-5">
                    <v-col cols="12">
                        <v-text-field label="Footer" v-model="modello.footer">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row dense align="center" justify="center" class="ml-5 mr-5">
                    <v-col cols="6">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="mr-5"
                                    @click="openRichText"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="primary">
                                        mdi-text-box-edit
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Apri Rich Text Editor</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="6" />
                </v-row>
                <v-row dense align="center" justify="center" class="ml-5 mr-5">
                    <v-col cols="6">
                        <v-textarea
                            rows="6"
                            outlined
                            label="Body"
                            v-model="modello.body"
                        >
                        </v-textarea>
                    </v-col>
                    <v-col cols="6" class="pt-0 mt-0 mb-5">
                        <v-container
                            label="HTML preview"
                            style="
                                border: 1px solid gray;
                                width: 40vw;
                                overflow-x: auto;
                                height: 24vh;
                                display: inline-block;
                            "
                            v-html="modello.body"
                        ></v-container></v-col
                ></v-row>
            </v-card-text>

            <v-dialog v-model="RichTextDialog">
                <v-card>
                    <v-toolbar
                        class="white--text"
                        color="indigo"
                        style="position: sticky; top: 0px; z-index: 1"
                        dense
                    >
                        <v-toolbar-title>Rich Text Editor</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- Bottone di salvataggio -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="saveRichText"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="success">
                                        mdi-floppy
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Salva</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <!-- Bottone di chiusura -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="RichTextDialog = false"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>
                            </template>
                            <span>Annulla</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col :cols="12">
                                <div
                                    style="
                                        position: relative;
                                        height: 275px;
                                        overflow-y: hidden;
                                    "
                                >
                                    <WindowFrame
                                        class="ma-0 pa-0"
                                        :component="'fwk'"
                                        ref="windowframe_fwk"
                                        :input_args="input_args_fwk"
                                        :key="key_fwk"
                                        @saverichtext="saveRichTextEvent"
                                    />
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <!-- Dialog modelli standard -->
            <v-dialog v-model="dialog_modello_standard" width="unset">
                <v-card min-width="600px">
                    <v-toolbar
                        class="white--text"
                        color="indigo"
                        style="position: sticky; top: 0px; z-index: 1"
                        dense
                    >
                        <v-toolbar-title>Modelli standard</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- Bottone di salvataggio -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="
                                        salva();
                                        dialog_modello_standard = false;
                                    "
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="success">
                                        mdi-floppy
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Salva</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <!-- Bottone di chiusura -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="dialog_modello_standard = false"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon color="error"> mdi-close </v-icon>
                                </v-btn>
                            </template>
                            <span>Annulla</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-card-text class="mt-5 mb-0 pb-5">
                        <v-autocomplete
                            background-color="#ffffff"
                            return-object
                            :items="lista_modelli_standard"
                            label="Seleziona un modello"
                            :item-text="(e) => e.des_modello"
                            v-model="modello_standard"
                        >
                        </v-autocomplete>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
export default {
    name: "ModelloEvento",
    components: { WindowFrame },
    props: ["selez", "nuovo"],
    data() {
        return {
            RichTextDialog: false,
            input_args_fwk: {
                landing_page: "/richtext",
            },
            key_fwk: true,
            dialog_modello_standard: false,
            headers: [],
            modello: {
                id_modello: -1,
                des_modello: "",
                oggetto: "",
                header: "",
                footer: "",
                body: "",
            },
            lista_modelli_standard: [],
            modello_standard: {},
        };
    },

    methods: {
        openRichText(){
            this.key_fwk = !this.key_fwk;
            this.RichTextDialog = true;
        },
        saveRichText() {
            this.$refs.windowframe_fwk.postEvent("getrichtexthtml");
        },
        saveRichTextEvent(e) {
            this.modello.body = e.html;
            this.RichTextDialog = false;
        },
        getHTML() {
            this.$emit("crea_HTML");
        },

        getModelliStandard() {
            let request = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "geteventiemailmodello",
                    token: localStorage.user_token,
                },
            };

            this.$store.dispatch("api6", request).then((res) => {
                this.overlay = false;
                if (res.data.result.length != 0) {
                    this.lista_modelli_standard = [];
                    res.data.result.forEach((e) => {
                        e.headers = e.header;
                        delete e.header;
                        this.lista_modelli_standard.push(e);
                    });
                    console.log(this.lista_modelli_standard);
                } else {
                    console.log("Non ci sono modelli.");
                }
            });
        },

        salva() {
            // assegnare il modello standard al modello generico, non si può più modificare!
            (this.modello = {
                id_modello: -1,
                des_modello: this.modello_standard.des_modello,
                oggetto: this.modello_standard.oggetto,
                header: this.modello_standard.headers,
                footer: this.modello_standard.footer,
                body: this.modello_standard.body,
            }),
                console.log(this.modello);
        },

        salvaModelloStandard() {
            let request = {
                controller: "notice",
                method: "PUT",
                richiesta: {
                    token: localStorage.user_token,
                    action: "saveeventoemailmodello",
                    modello: [
                        {
                            id_evento_email_modello: this.modello.id_modello,
                            des_modello: this.modello.des_modello,
                            oggetto: this.modello.oggetto,
                            header: this.modello.header,
                            footer: this.modello.footer,
                            body: this.modello.body,
                            validita: 1,
                        },
                    ],
                },
            };
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        console.log("salvataggio fatto");
                        // Stampo una snackbar di conferma.
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Salvataggio effettuato."
                        );
                    }
                })
                .catch((err) => {
                    // Stampo una snackbar di avviso.
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );

                    // Stampo il log dell'errore in console.
                    console.error(err);
                });
        },
    },

    computed: {},

    watch: {},

    mounted() {
        //Da riattivare se ripristiniamo i modelli standard
        //this.getModelliStandard();
        if (!this.nuovo && this.selez.id_evento_email_modello) {
            this.modello = {
                id_modello: this.selez.id_evento_email_modello,
                des_modello: this.selez.des_modello,
                oggetto: this.selez.oggetto,
                header: this.selez.header,
                footer: this.selez.footer,
                body: this.selez.body,
            };
        }
    },
};
</script>
<style scoped></style>
